import { Link } from "react-router-dom";
import { allWorks } from "@/lib/works";
import { newsList } from "@/mocks/news";

const STATS = [
  {
    icon: "ri-movie-2-line",
    value: `${allWorks.length}+`,
    label: "在库影视作品",
    tone: "bg-primary-50 text-primary-600",
  },
  {
    icon: "ri-newspaper-line",
    value: `${newsList.length}+`,
    label: "最新资讯条目",
    tone: "bg-accent-100 text-accent-800",
  },
  {
    icon: "ri-list-check-2",
    value: "3",
    label: "影视类型频道",
    tone: "bg-secondary-100 text-secondary-800",
  },
  {
    icon: "ri-time-line",
    value: "每日",
    label: "资讯更新频率",
    tone: "bg-primary-50 text-primary-600",
  },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-8 px-4 md:px-6 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-primary-600">
            <i className="ri-information-line"></i>
            关于甜蜜的惩罚
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            一个专注影视资讯与剧情介绍的门户
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            甜蜜的惩罚面向所有热爱影视剧的观众，覆盖电视剧、电影与网剧多类型作品。
            我们把散落在各处的开播动态、口碑讨论与剧情概要整理在一起，
            让你在追剧之前先了解故事走向，在讨论剧情时能找到完整的脉络。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            无论是想快速获取最新影视资讯，还是想深入了解某个作品的剧情细节，
            都可以在这里按分类浏览、按关键词搜索，并收藏感兴趣的作品。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/drama"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              开始浏览
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${stat.tone}`}
              >
                <i className={stat.icon}></i>
              </span>
              <p className="mt-3.5 font-heading text-2xl font-bold text-foreground-950">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}